import React from 'react';
import CountView from './CountView';
import 'antd/dist/antd.min.css';

const Budgeting = () => {
    return(
        <div>
            <CountView></CountView>
        </div>
    )
}

export default Budgeting;